import feather from "feather-icons";
import WaveSurfer from "wavesurfer.js";
import Tablesort from "tablesort";
import { decodePeaks } from "./peaks.js";
import feather from "feather-icons";

feather.replace();

Tablesort.extend(
  "float",
  (s) => Number.isFinite(Number.parseFloat(s)),
  (a, b) => Number.parseFloat(a) - Number.parseFloat(b)
);
for (const sampleTable of document.querySelectorAll("table.sortable")) {
  new Tablesort(sampleTable);
}

function e(spec) {
  const [eltName, ...classes] = spec.split(".");
  const elt = document.createElement(eltName);
  elt.classList.add(...classes);
  return elt;
}

function iconButton(featherIconName) {
  const btn = e("button.icon-button");
  btn.innerHTML = feather.icons[featherIconName].toSvg();
  return btn;
}

const allWaveSurfers = [];

function setupAudioCell(audioCell, duration, widthFraction) {
  //build elements
  const playerElt = e("div.player");
  const controlsElt = e("div.controls");
  playerElt.append(controlsElt);
  const playButton = iconButton("play");
  playButton.setAttribute("title", "Play audio sample");
  const pauseButton = iconButton("pause");
  pauseButton.setAttribute("title", "Pause audio sample");
  pauseButton.querySelector(".feather-pause").classList.add("color-pause");
  controlsElt.appendChild(playButton);
  controlsElt.appendChild(pauseButton);
  const waveformElt = e("div.waveform");
  playerElt.append(waveformElt);
  //add player to audio cell
  const audioElt = audioCell.querySelector("audio");
  const peaks = decodePeaks(audioElt.getAttribute("data-peaks"));
  audioElt.style.display = "none";
  audioCell.appendChild(playerElt);
  //setup waveform
  const percentWidth = Math.max(10, (widthFraction || 1) * 100);
  const wavesurfer = WaveSurfer.create({
    media: audioElt,
    container: waveformElt,
    waveColor: "#fff",
    progressColor: "#fc3",
    width: percentWidth.toFixed(2) + "%",
    height: "auto",
    dragToSeek: true,
    cursorWidth: 0,
    normalize: true,
    peaks: peaks,
    barWidth: 0,
    barGap: 0,
    barRadius: 0,
    url: audioElt.src,
    duration: duration,
  });
  function setIsPlaying(isPlaying) {
    playButton.style.display = isPlaying ? "none" : null;
    pauseButton.style.display = isPlaying ? null : "none";
  }
  wavesurfer.on("play", () => setIsPlaying(true));
  wavesurfer.on("pause", () => setIsPlaying(false));
  wavesurfer.on("finish", () => {
    setIsPlaying(false);
    wavesurfer.stop();
  });
  setIsPlaying(false);
  playButton.addEventListener("click", () => {
    for (const ws of allWaveSurfers) {
      if (ws !== wavesurfer) {
        ws.stop();
      }
    }
    wavesurfer.play();
  });
  pauseButton.addEventListener("click", () => wavesurfer.pause());
  allWaveSurfers.push(wavesurfer);
}

function setupCopyCell(copyCell, textToCopy) {
  const copyButton = iconButton("copy");
  copyButton.innerHTML += feather.icons.check.toSvg();
  const copyIcon = copyButton.querySelector(".feather-copy");
  const checkIcon = copyButton.querySelector(".feather-check");
  checkIcon.classList.add("color-green");
  const setShowCheck = (showCheck) => {
    copyIcon.style.display = showCheck ? "none" : null;
    checkIcon.style.display = showCheck ? null : "none";
  };
  setShowCheck(false);
  copyButton.setAttribute("title", "Copy the TTS message to clipboard");
  copyCell.appendChild(copyButton);
  copyCell.addEventListener("click", () => {
    navigator.clipboard.writeText(textToCopy).then(() => {
      setShowCheck(true);
      setTimeout(() => setShowCheck(false), 1600);
    });
  });
}

function setupSampleRow(sampleRow) {
  const copyCell = sampleRow.querySelector("td.copy");
  const voiceCell = sampleRow.querySelector("td.voice");
  const wordCell = sampleRow.querySelector("td.word");
  const lengthCell = sampleRow.querySelector("td.length");
  const audioCell = sampleRow.querySelector("td.audio");
  const voice = voiceCell.innerText.trim().replaceAll(/\s+/g, " ");
  const word = wordCell.innerText.trim().replaceAll(/\s+/g, " ");
  const length = Number.parseFloat(lengthCell.innerText.trim()) || 0;
  const ttsMessage = voice + ": " + word;
  //setup UI elements, scaling waveform width
  setupCopyCell(copyCell, ttsMessage);
  setupAudioCell(audioCell, length, length / 18.57);
}

const sampleRows = document.querySelectorAll(".sample-row");
for (const sampleRow of sampleRows) {
  setupSampleRow(sampleRow);
}

const filterInput = document.querySelector("#filter-form .filter-text");
const filterResetBtn = document.querySelector("#filter-form .filter-reset-btn");
filterInput.addEventListener("input", () => {
  const filterValue = filterInput.value.trim().toLowerCase();
  filterResetBtn.style.display = filterValue ? "" : "none";
  const filterWords = filterValue.split(/\s+/).filter(Boolean);
  const tables = document.querySelectorAll("table.filterable");
  for (const table of tables) {
    const rows = table.querySelectorAll("tbody tr.filter-candidate");
    let anyMatch = false;
    const results = [];
    for (const row of rows) {
      const rowText = row.innerText.toLowerCase();
      const matches = filterWords.every((word) => rowText.includes(word));
      results.push([row, matches]);
      if (matches) {
        anyMatch = true;
      }
    }
    for (const [row, matches] of results) {
      row.classList.toggle("hidden", !matches);
    }
    const noMatchesRow = table.querySelector("tbody tr.filter-no-matches");
    noMatchesRow.classList.toggle("hidden", anyMatch);
  }
});
filterResetBtn.addEventListener("click", () => {
  filterInput.value = "";
  filterInput.dispatchEvent(new Event("input"));
});
